export default {
  title: 'マーケティングデータ',
  activityInfo: 'アクティビティ情報',
  activityInfoPlaceholder: 'アクティビティ名またはIDを入力',
  dateRange: '日付範囲',
  startDate: '開始日',
  endDate: '終了日',
  // KPI カード
  totalScanCount: 'スキャン総数',
  cumulativeScanCount: '累計スキャン数',
  scanUserCount: 'スキャン利用者数',
  activityUserCount: 'アクティビティ参加者数',
  winUserCount: '当選者数',
  yesterday: '昨日:',
  // トレンドチャート
  trendTitle: 'スキャントレンド',
  periodWeek: '今週',
  periodMonth: '今月',
  scanCount: 'スキャン数',
  scanCountSeries: 'スキャン数',
  scanUserCountSeries: 'スキャン利用者数',
  winCount: '当選者数',
  // ランキング
  rankTitle: 'スキャン製品ランキング（TOP10）',
  rankNo: '順位',
  productName: '製品',
  scanCountCol: 'スキャン数',
};
